import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { MenuItem } from '../nested-menu.module';
import {
  RolePermissionService,
  SidebarStateService,
  StorageService,
} from '@optimo/core';
import { INestedMenuItem } from '../interface/INestedMenuItem';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemComponent implements OnInit {
  @Input()
  item: INestedMenuItem;

  @Input()
  hasGlovoIntegration: any;

  @Input()
  level: number;

  @Input()
  userDetails: object;

  active = false;
  locationId: string;

  navigatedToChild = false;

  mouseOverItem = new Subject<boolean>();
  mouseIsOver = false;

  constructor(
    private sidebarStateService: SidebarStateService,
    private cdr: ChangeDetectorRef,
    private storage: StorageService,
    private rolePermission: RolePermissionService,
  ) {}

  ngOnInit(): void {
    this.locationId = this.getLocationId();
    if (this.item.children) {
      this.sidebarStateService.selectedMenuItem.subscribe(
        (menuItem: MenuItem) => {
          this.active = this.item?.children.find(
            (curItem) =>
              menuItem &&
              menuItem.text === menuItem.text &&
              curItem.path === menuItem.path,
          )
            ? true
            : false;
          this.navigatedToChild = this.active;
          this.cdr.markForCheck();
        },
      );
    }
    this.mouseOverItem.pipe(debounceTime(10)).subscribe((mouseIsOver) => {
      this.setHoveredState(mouseIsOver);
    });
  }

  isGlovoIntegration(item: any) {
    return (
      !item.checkGlovoIntegration ||
      (item.checkGlovoIntegration && this.hasGlovoIntegration)
    );
  }

  private setHoveredState(mouseIsOver: boolean): void {
    this.mouseIsOver = mouseIsOver;
    this.cdr.markForCheck();
  }

  private getLocationId(): string {
    if (this.storage.get('locationId') === null) {
      return '1';
    }
    return this.storage.get('locationId');
  }

  toggleSubNav() {
    this.active = !this.active;
  }

  hasPermission(_item: INestedMenuItem): boolean {
    // const permissions = this.rolePermission.getRolePermissionMap();
    // if (_item.permission !== undefined) {
    //   if (_item.children) {
    //     return _item.children.some(
    //       (child: INestedMenuItem) =>
    //         !!permissions[ERolesPermission[child.permission]],
    //     );
    //   } else {
    //     return !!permissions[ERolesPermission[_item.permission]];
    //   }
    // }
    return true;
  }
}
